import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'nb';
    document.title = 'KUNSTKLAR™ – Ferdige økter i kunst og håndverk for 1.–10. trinn';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mjzrt22ccy08">
      <div lang="nb" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3rc9dg5wfbbwp">
        <CountdownBar data-id="element-2" data-mp="3relvsk63foaa" />
        <main data-id="element-3" data-mp="6hrlipoilfp">
          <Hero data-id="element-4" data-mp="682rygdekbl" />
          <StatsBar data-id="element-5" data-mp="4n7g6m8exco" />
          <Difference data-id="element-6" data-mp="82ld64660ci" />
          <Recognize data-id="element-7" data-mp="2zl3c5m4yv85u" />
          <WhatsInside data-id="element-8" data-mp="2zlv6ktmtuzuj" />
          <InsidePages data-id="element-9" data-mp="2zmenc70qri6z" />
          <Bonuses data-id="element-10" data-mp="2zn6aquk6q9m6" />
          <HowItWorks data-id="element-11" data-mp="33mow1rfx4mpj" />
          <Audience data-id="element-12" data-mp="33m5e4aq9pybi" />
          <Offer data-id="element-13" data-mp="33ngdzzglelxc" />
          <Guarantee data-id="element-14" data-mp="33mymth8sexwa" />
          <Testimonials data-id="element-15" data-mp="33oi0r16z0wuw" />
          <Faq data-id="element-16" data-mp="38l8j5v6904jh" />
          <FinalCta data-id="element-17" data-mp="38kqd66tsabyd" />
        </main>
        <Footer data-id="element-18" data-mp="38kgocmkh6au9" />
      </div>
    </MotionConfig>;
}